import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { VideoCameraOutline } from '@bonusly/design-system';
import { useFeatureFlag } from '@bonusly/who-am-i';

import { ExperimentCard } from '../components/experiment-card';
import { FlagStatus } from '../components/flag-status';

const FLAG = 'labs-video-conferencing-1on1';

export const VideoConferencing1on1Experiment: FC = () => {
	const { t } = useTranslation('labs');
	const isEnabled = useFeatureFlag(FLAG);

	return (
		<ExperimentCard
			icon={<VideoCameraOutline size="md" />}
			title={t('experiments.videoConferencing1on1.title')}
			description={t('experiments.videoConferencing1on1.description')}
			footer={<FlagStatus flagName={FLAG} isEnabled={isEnabled} />}
		/>
	);
};
